import React from 'react'
import "./termsconditions.css"; 
export const Termsconditions = () => {
  return (
 


    <div className="terms-wrapper py-4">
  <div className="terms-header">
    <h1>Terms &amp; Conditions</h1>
    
    <p>
      Welcome to https://topfaculty.co.in/. By accessing or using this Website,
      you agree to comply with the following Terms and Conditions.
    </p>
  </div>
  <div className="terms-grid">
    <div className="term-card">
      <div className="number">1</div>
      <h2>Acceptance of Terms</h2>
      <p>
        By using this Website, you confirm that you are at least 18 years old or
        accessing the Website under supervision of a parent/guardian.
      </p>
      <p>Continued use of the Website indicates acceptance of these Terms.</p>
    </div>
    <div className="term-card">
      <div className="number">2</div>
      <h2>Services Provided</h2>
      <ul>
        <li>Academic coaching information</li>
        <li>Course counselling guidance</li>
        <li>Faculty interaction coordination</li>
        <li>Student enquiry facilitation</li>
        <li>Batch availability updates</li>
        <li>Educational infrastructure support information</li>
      </ul>
      <p>
        TopFaculty does not guarantee selection, results, or admission outcomes
        unless explicitly mentioned in writing.
      </p>
    </div>
    <div className="term-card">
      <div className="number">3</div>
      <h2>User Responsibilities</h2>
      <ul>
        <li>Provide accurate personal and academic details</li>
        <li>Not submit false documentation</li>
        <li>Not misuse website services</li>
        <li>Follow institutional rules after enrolment</li>
      </ul>
      <p>Violation may result in cancellation of services.</p>
    </div>
    <div className="term-card">
      <div className="number">4</div>
      <h2>Admission &amp; Result Disclaimer</h2>
      <ul>
        <li>Student eligibility</li>
        <li>Seat availability</li>
        <li>Institutional rules</li>
        <li>Examination performance</li>
      </ul>
      <p>TopFaculty acts only as a guidance and facilitation platform.</p>
    </div>
    <div className="term-card">
      <div className="number">5</div>
      <h2>Payment Terms</h2>
      <p>
        Students must complete applicable payments before confirmation of
        registration or batch allocation.
      </p>
      <p>
        All payments remain subject to the Refund Policy published on this
        Website.
      </p>
    </div>
    <div className="term-card">
      <div className="number">6</div>
      <h2>Intellectual Property Rights</h2>
      <ul>
        <li>Text</li>
        <li>Graphics</li>
        <li>Logos</li>
        <li>Layout</li>
        <li>Branding materials</li>
      </ul>
      <p>
        All website content is the property of TopFaculty and cannot be copied
        without permission.
      </p>
    </div>
    <div className="term-card">
      <div className="number">7</div>
      <h2>Third-Party Links</h2>
      <p>
        The Website may include links to external educational institutions or
        partner platforms.
      </p>
      <ul>
        <li>Third-party website accuracy</li>
        <li>External content updates</li>
        <li>External privacy policies</li>
      </ul>
      <p>Users should verify information independently.</p>
    </div>
    <div className="term-card">
      <div className="number">8</div>
      <h2>Limitation of Liability</h2>
      <ul>
        <li>Academic performance outcomes</li>
        <li>Admission rejection</li>
        <li>Batch rescheduling due to operational reasons</li>
        <li>Technical interruptions</li>
        <li>Delays beyond institutional control</li>
      </ul>
    </div>
    <div className="term-card">
      <div className="number">9</div>
      <h2>Privacy Policy Reference</h2>
      <p>Use of this Website is also governed by our Privacy Policy.</p>
    </div>
    <div className="term-card">
      <div className="number">10</div>
      <h2>Termination of Access</h2>
      <ul>
        <li>Terms are violated</li>
        <li>Fraudulent activity is detected</li>
        <li>Website misuse occurs</li>
      </ul>
      <p>TopFaculty reserves the right to suspend services if necessary.</p>
    </div>
    <div className="term-card">
      <div className="number">11</div>
      <h2>Governing Law</h2>
      <p>
        These Terms shall be governed by the laws of India. Any disputes shall
        fall under the jurisdiction of courts located in New Delhi.
      </p>
    </div>
    <div className="term-card">
      <div className="number">12</div>
      <h2>Changes to Terms</h2>
      <p>
        TopFaculty reserves the right to modify these Terms at any time.
        Continued use of the Website indicates acceptance of updated Terms.
      </p>
    </div>
  </div>
  
</div>


  )
}
